import * as React from 'react';

import { enumLoadStatus } from '@rematter/frontend-lib-api-client';
import { useAtomValue, useSetAtom } from 'jotai';

import {
  $flushOutboundNotesAutoSave,
  $outboundNotesFormById,
  $updateOutboundNotesField,
  DEFAULT_OUTBOUND_NOTES_FORM,
} from '~/modules/trade/_state/scaleTicketOutboundNotesForm.state';
import { $outboundTicketDetail } from '~/modules/trade/_state/scaleTicketPro.state';
import { EntityTabNotes } from '~/shared/components/EntityTabNotes';

export const OutboundTicketTabNotes = () => {
  const loadResult = useAtomValue($outboundTicketDetail);
  const load = loadResult?.data?.load ?? null;

  const notesFormMap = useAtomValue($outboundNotesFormById);
  const notesForm =
    (load?.id ? notesFormMap.get(load.id) : undefined) ??
    DEFAULT_OUTBOUND_NOTES_FORM;
  const updateNotesField = useSetAtom($updateOutboundNotesField);
  const flushNotesAutoSave = useSetAtom($flushOutboundNotesAutoSave);

  const isReadonly =
    load?.status === enumLoadStatus.Voided ||
    load?.status === enumLoadStatus.Shipped;

  const handleChange = React.useCallback(
    (notes: { internalNotes: string; externalNotes: string }) => {
      if (!load?.id) return;
      updateNotesField({
        field: 'recyclerInternalNotes',
        value: notes.internalNotes,
        ticketId: load.id,
      });
      updateNotesField({
        field: 'recyclerExternalNotes',
        value: notes.externalNotes,
        ticketId: load.id,
      });
    },
    [load?.id, updateNotesField],
  );

  const handleSave = React.useCallback(async () => {
    if (!load?.id) return;
    flushNotesAutoSave(load.id);
  }, [load?.id, flushNotesAutoSave]);

  if (!load) {
    return null;
  }

  return (
    <EntityTabNotes
      key={load.id}
      className="@OutboundTicketTabNotes p-0"
      counterparty="customer"
      isReadonly={isReadonly}
      internalNotes={notesForm.recyclerInternalNotes ?? ''}
      externalNotes={notesForm.recyclerExternalNotes ?? ''}
      onSave={handleSave}
      onChange={handleChange}
    />
  );
};
